import { Order } from "../typings";

export const getOrderType = ({ database }: Order): string => {
  if (database === "Fungi-SSP") return 'fungi';
  if (database === "Escherichia-coli-spectra-quality") return "quality";
  if (database === "Mosquito-vectors") return "mosquito";
  return "bacteria";
};
